export default __webpack_public_path__ + "static/media/dozule11.b7a1b27d.jpg";